// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"f80efae507d142e3826a","883":"8fe9fbf68502f59cbabe"}[chunkId] + ".js";
};